import { useParams } from 'react-router-dom'

export type AccessType = 'one-time-access' | 'time-access' | 'permanent-access'

const useAccessParams = () => {
  const params = useParams<{ id: string, type: string, action: AccessType, typeId?: string }>()
  return params
}

export default useAccessParams